// extracted by mini-css-extract-plugin
module.exports = {"viewport":"JOsa8wjzfwgGcDgRGJklwg=="};